import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { SectionHeading } from './SectionHeading';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  const reduce = useReducedMotion();
  return <section className="bg-paper py-14 lg:py-24" data-id="element-59" data-mp="1geimufhsgv0a">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-60" data-mp="2e0zfv8jhomg8">
        <SectionHeading title="Frequently Asked Questions" data-id="element-61" data-mp="2dyda9eg5sh0n" />

        <ul className="mt-8 border-t border-cream-line lg:mt-12" data-id="element-62" data-mp="292eidgvmggvh">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          const id = `faq-${i}`;
          return <li key={item.question} className="border-b border-cream-line" data-id="element-63" data-mp="1z25hhpqoq79r" data-mpi={i}>
                <h3 data-id="element-64" data-mp="snmnmxb06xj0">
                  <button type="button" aria-expanded={isOpen} aria-controls={id} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-6 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-terra-deep" data-id="element-65" data-mp="so68omvya219">
                    <span className="text-[17px] font-semibold text-ink sm:text-[18px]" data-id="element-66" data-mp="fji6b5yiy8f4">{item.question}</span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-terra-deep transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-67" data-mp="kko43i71klvi" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-68" data-mp="3t0hklx1dhxck">
                  {isOpen && <motion.div id={id} initial={reduce ? false : {
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={reduce ? {
                opacity: 0
              } : {
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-69" data-mp="1t531gwkvhw4">
                      <div className="space-y-3 pb-6 pr-10 text-[17px] leading-relaxed text-ink-soft" data-id="element-70" data-mp="1pob8oy9utel8">
                        {item.answer.split('\n\n').map(paragraph => <p key={paragraph} data-id="element-71" data-mp="1ftrpjqs1m53r">{paragraph}</p>)}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}